import React from 'react'
import {NoticeListComponents} from './NoticeListComponents'
import {Line} from '../../Atoms/Line'
import {PIMStack} from '../../Atoms/Layouts/Bases/PIMStack'
import {MBContentBodyTypography, MBContentSubTitleTypography} from '../../Atoms/Typographies'

type ConfirmContentProps = {
  label: string
  values: string[]
  valueColor?: string
  notices?: string[]
  testDataId?: string
}

export const ConfirmContent: React.VFC<ConfirmContentProps> = (props) => {
  return (
    <PIMStack spacing={'10px'} testId={props.testDataId}>
      <MBContentSubTitleTypography>{props.label}</MBContentSubTitleTypography>
      <div>
        <MBContentBodyTypography>
          {props.values?.map((value, i) => {
            return (<Line key={i} color={props.valueColor}>{value}&nbsp;</Line>)
          })}
        </MBContentBodyTypography>
        {props.notices && <NoticeListComponents notices={props.notices}/>}
      </div>
    </PIMStack>
  )
}
